import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-better-success-message',
  templateUrl: './better-success-message.component.html',
  styleUrls: ['./better-success-message.component.css']
})
export class BetterSuccessMessageComponent implements OnInit {

  @Input() displayMessage: boolean;
  @Input() message: string;

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    
  }
}
